module.exports = __webpack_public_path__ + "img/img40.e71036d7.svg";